import { Flex } from '@utilitywarehouse/hearth-react';
import clsx from 'clsx';

import { BreakdownItem } from '@components/BreakdownItem';

import { getNotCoveredItems } from './notCoveredItems';

const ListNotCovered = () => {
  const notCoveredItems = getNotCoveredItems();

  return (
    <Flex spacing="md" direction="column" asChild>
      <ul
        className={clsx('boilerHomeCoverCovered__BreakdownList', 'notCovered')}
      >
        {notCoveredItems.map((item, index) => (
          <BreakdownItem key={index} type="notCovered">
            {item}
          </BreakdownItem>
        ))}
      </ul>
    </Flex>
  );
};

export { ListNotCovered };
